import React, { Component } from 'react';
import {Divider, Header, Segment, Button, Message} from 'semantic-ui-react';
import { Formik, Form, Field } from 'formik';
import _ from 'underscore';

import FormsInputsText from '../../inputs/text/forms_inputs_text';
import FormsInputDropdown from '../../inputs/dropdown';
import ConfirmIdentitySchema from './validate';

const prepareCountryCodeOptions = (list) => {
    return _.map(list, (item) => {
        return { text: `${item.code} (${item.label})`, value: item.code };
    })
}

class FormsConfirmIdentity extends Component {
    state = {
        error: false,
        errorMessage: null,
        success: false
    }

    renderFormSubmissionResult() {
        if (this.state.error === true) {
            return (
                <Message negative>
                    <Message.Header>We're sorry - there is an issue</Message.Header>
                    <p>
                        { this.state.errorMessage }
                    </p>
                </Message>
            );
        }
    }

    render() {
        const {
            updateStepIndex,
            identifier,
            name,
            contactNoCountryCode,
            contactNo,
            countryCodes,
            requireRegistrationEmail,
            emailEditable,
            email
        } = this.props;
        const countryCodeOptions = prepareCountryCodeOptions(countryCodes);
        return (
            <Formik
                initialValues={{
                    nric: identifier,
                    name,
                    contactNoCountryCode,
                    contactNo
                }}
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={ConfirmIdentitySchema}
                onSubmit={(values, actions) => {
                    // console.log(values, actions);
                    const {name, contactNo, contactNoCountryCode} = values;
                    this.setState({error: false, errorMessage: null});
                    if(requireRegistrationEmail){
                        updateStepIndex(3, 
                        {
                            name,
                            contactNo,
                            contactNoCountryCode
                        });
                    }else{
                        this.props.registerGenerateOTPEmail({
                            nric: identifier,
                            email: email
                        }, (result, error) => {
                            console.log(result, error);
                            if (error) {
                                this.setState({error: true, errorMessage: error.errorMessage});
                                actions.setSubmitting(false);
                            }
                            if (result) {
                                updateStepIndex(4, {
                                    name,
                                    contactNo,
                                    contactNoCountryCode
                                });
                            }
                        });
                    }
                }}
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <Segment>
                        <Form>
                            <Header as='h2'>
                                Identification
                            </Header>
                            <Divider />
                            <Message warning>
                                <Message.Header>
                                    Hi, welcome to GroupCare@Income!
                                </Message.Header>
                                <p>
                                    Please check your personal details are correct and tap next to proceed
                                </p>
                            </Message>
                            <Field name="nric" label="" component={FormsInputsText} 
                                secondaryLabel="NRIC / FIN / Passport No." disabled={true}
                            />
                            &nbsp;
                            <Field name="name" label="" component={FormsInputsText} 
                                secondaryLabel="Name" disabled={true}
                            />
                            &nbsp;
                            <Field
                                name="contactNoCountryCode" 
                                options={countryCodeOptions} 
                                label="" 
                                secondaryLabel="Country Code"
                                component={FormsInputDropdown}
                            />
                            &nbsp;
                            <Field name="contactNo" label="" component={FormsInputsText} 
                                secondaryLabel="Mobile No."
                            />
                            &nbsp;
                            <Button 
                                type="submit" 
                                primary 
                                disabled={isSubmitting} 
                                fluid 
                                loading={isSubmitting}
                            >
                                Next
                            </Button>
                            <p>
                                &nbsp;
                            </p>
                            {
                                this.renderFormSubmissionResult()
                            }
                        </Form>
                    </Segment>
                )}
            />            
        );
    }
}

export default FormsConfirmIdentity;